/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import moment from "moment/moment";
import FeesService from "../FeesService";

class CostCalculator {
  static settlementValue(settlement) {
    return Math.round(moment().diff(moment(settlement.employedSince), "days") / 365) * settlement.grossSalary * 0.5;
  }

  static calculateValueInDispute(settlement) {
    return settlement.grossSalary * 3;
  }

  static getProcessCost(valueInDispute, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.3, addVat);
  }

  static getHearingCost(valueInDispute, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.2, addVat);
  }

  static getSettlementCost(valueInDispute, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.0, addVat);
  }

  static getCourtCosts(valueInDispute) {
    return FeesService.getCourtCosts(valueInDispute, 2.0);
  }

  static getFullCosts(valueInDispute, addVat = true) {
    return (
      this.getProcessCost(valueInDispute, addVat) +
      this.getHearingCost(valueInDispute, addVat) +
      FeesService.getExpenses(addVat)
    );
  }
}

export default CostCalculator;
